const initGiftGuide = () => {
    // 1. Fade-in Animation Observer
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    const fadeElements = document.querySelectorAll('.animate-fade-in, .animate-rich-reveal');
    fadeElements.forEach(el => observer.observe(el));

    // 2. Snow Particle Effect
    // Check if canvas exists before init to avoid errors
    if (document.getElementById('hero-snow')) {
        initSnow('hero-snow');
    }

    // 3. Slider Drag Functionality
    const sliders = document.querySelectorAll('.scene-slider');
    sliders.forEach(slider => {
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false;

        // Remove existing listeners to avoid duplicates if re-initialized? 
        // Actually, replacing the element removes listeners, so it's fine.

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            isDragging = false;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
            slider.style.cursor = 'grabbing';
            slider.style.scrollBehavior = 'auto';
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.style.cursor = 'grab';
            slider.style.scrollBehavior = 'smooth';
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.style.cursor = 'grab';
            slider.style.scrollBehavior = 'smooth';
            setTimeout(() => { isDragging = false; }, 10);
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2;
            if (Math.abs(walk) > 5) {
                isDragging = true;
            }
            slider.scrollLeft = scrollLeft - walk;
        });

        slider.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', (e) => {
                if (isDragging) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
            link.querySelectorAll('img').forEach(img => {
                img.addEventListener('dragstart', (e) => e.preventDefault());
            });
        });
    });
};

document.addEventListener("DOMContentLoaded", initGiftGuide);

// Shopify Theme Editor Events
document.addEventListener('shopify:section:load', initGiftGuide);
document.addEventListener('shopify:section:select', (event) => {
    // Force visibility on selection for easier editing
    const section = event.target;
    const hiddenElements = section.querySelectorAll('.animate-fade-in, .animate-rich-reveal');
    hiddenElements.forEach(el => el.classList.add('is-visible'));
    initGiftGuide();
});

function initSnow(canvasId) {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let width = canvas.width = canvas.parentElement.clientWidth;
    let height = canvas.height = canvas.parentElement.clientHeight;

    const imageUrl = canvas.dataset.particleImage;
    let particleImg = null;

    if (imageUrl) {
        particleImg = new Image();
        particleImg.src = imageUrl;
    }

    window.addEventListener('resize', () => {
        width = canvas.width = canvas.parentElement.clientWidth;
        height = canvas.height = canvas.parentElement.clientHeight;
    });

    const particles = [];
    const particleCount = 40;

    class Particle {
        constructor() {
            this.reset(true);
        }

        reset(initial = false) {
            this.x = Math.random() * width;
            this.y = initial ? Math.random() * height : -20;
            this.speed = 0.2 + Math.random() * 0.4;

            const baseSize = particleImg ? 10 : 2;
            this.radius = baseSize + Math.random() * (particleImg ? 15 : 3);
            this.opacity = 0.4 + Math.random() * 0.5;
            this.wind = (Math.random() - 0.5) * 0.5;
            this.wiggle = Math.random() * Math.PI * 2;

            this.rotation = Math.random() * 360;
            this.rotationSpeed = (Math.random() - 0.5) * 2;
        }

        update() {
            this.y += this.speed;
            this.wiggle += 0.05;
            this.x += Math.sin(this.wiggle) * 0.5 + this.wind;
            this.rotation += this.rotationSpeed;

            if (this.y > height + 20) {
                this.reset();
            }
        }

        draw() {
            ctx.save();
            ctx.globalAlpha = this.opacity;

            if (particleImg && particleImg.complete) {
                ctx.translate(this.x, this.y);
                ctx.rotate(this.rotation * Math.PI / 180);
                ctx.drawImage(particleImg, -this.radius / 2, -this.radius / 2, this.radius, this.radius);
            } else {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
                ctx.fillStyle = "#ffffff";
                ctx.fill();
            }

            ctx.restore();
        }
    }

    for (let i = 0; i < particleCount; i++) {
        particles.push(new Particle());
    }

    function animateSnow() {
        ctx.clearRect(0, 0, width, height);
        particles.forEach(p => {
            p.update();
            p.draw();
        });
        requestAnimationFrame(animateSnow);
    }
    animateSnow();
}
